export default function(o, id){

  var lang = o.store('lang')

  var translations = {

    comingSoon: {
      de: 'Weltpremiere 23.09.2019',
      fr: 'Première mondiale 23.09.2019',
      en: 'World premiere 23.09.2019',
      ru: 'мировая премьера 23.09.2019',
    },

    wrongCode: {
      de: 'Falscher code',
      fr: 'Mauvais code',
      en: 'Wrong code',
      ru: 'Неверный код',
    },

    earlyAccess: {
      de: 'beta zugang',
      fr: 'accès bêta',
      en: 'beta access',
      ru: 'бета-доступ',
    },

    pressDownloads: {
      de: 'presse downloads',
      fr: 'accès presse',
      en: 'presse downloads',
      ru: 'загрузка прессы',
    },

    enter: {
      de: 'betreten',
      fr: 'entrer',
      en: 'enter',
      ru: 'войти',
    },

    loading: {
      de: 'loading',
      fr: 'loading',
      en: 'loading',
      ru: 'погрузка',
    },

    back: {
      de: 'zurück',
      fr: 'retour',
      en: 'back',
      ru: 'назад',
    },

    random: {
      de: 'zufall',
      fr: 'aléatoire',
      en: 'random',
      ru: 'cлучайность',
    },

    antiArchive: {
      de: 'anti-archiv',
      fr: 'anti-archive',
      en: 'anti-archive',
      ru: 'анти-архив',
    },
    archive: {
      de: 'archiv',
      fr: 'archive',
      en: 'archive',
      ru: 'архив',
    },
    stories: {
      de: 'geschichten',
      fr: 'histoires',
      en: 'stories',
      ru: 'повесть',
    },
    facts: {
      de: 'fakten',
      fr: 'faits',
      en: 'facts',
      ru: 'факты',
    },
    searchPlaceholder: {
      de: 'Suche',
      fr: 'Recherche',
      en: 'Search',
      ru: 'Поиск',
    },
    searching: {
      de: 'Suchergebnis wird berechnet ...',
      fr: 'Le résultat de la recherche se calcule ...',
      en: 'Search result being calculated ...',
      ru: 'Результат поиска рассчитывается ...',
    },

    info: {
      de: 'info',
      fr: 'info',
      en: 'info',
      ru: 'Информация',
    },
    sponsors: {
      de: 'Förderer',
      fr: 'Sponsors',
      en: 'Funders',
      ru: 'спонсоры',
    },
    licence: {
      de: 'lizenz',
      fr: 'licence',
      en: 'license',
      ru: 'лицензия',
    },
    press: {
      de: 'presse',
      fr: 'presse',
      en: 'press',
      ru: 'пресс',
    },
    news: {
      de: 'neues',
      fr: 'nouvelles',
      en: 'news',
      ru: 'Новости',
    },
    contact: {
      de: 'kontakt',
      fr: 'contact',
      en: 'contact',
      ru: 'контакт',
    },
    login: {
      de: 'login',
      fr: 'connecter',
      en: 'login',
      ru: 'Войти',
    },

    logout: {
      de: 'ausloggen',
      fr: 'déconnexion',
      en: 'logout',
      ru: 'выход',
    },

    an: {
      de: 'an',
      fr: 'activé',
      en: 'on',
      ru: 'на',
    },
    off: {
      de: 'aus',
      fr: 'muet',
      en: 'off',
      ru: 'снятый',
    },

    sound: {
      de: 'ton',
      fr: 'son',
      en: 'sound',
      ru: 'звук',
    },


    project: {
      de: 'box',
      fr: 'box',
      en: 'box',
      ru: 'ЯЩИК',
    },
    roll: {
      de: 'rolle',
      fr: 'bobine',
      en: 'roll',
      ru: 'РУЛОН',
    },
    min: {
      de: 'Min',
      fr: 'Min',
      en: 'Min',
      ru: 'мин',
    },

    search: {
      de: 'archiv',
      fr: 'archive',
      en: 'archive',
      ru: 'архив',
    },
    results: {
      de: 'ergebnisse',
      fr: 'résultats',
      en: 'results',
      ru: 'Результаты',
    },
    noResults: {
      de: 'Die Suche hat keine Treffer.',
      fr: 'La recherche n\'a pas aucun résultat.',
      en: 'The search has no hits.',
      ru: 'У поиска нет попаданий.',
    },

    moreStories: {
      de: 'Weitere Geschichten folgen in Kürze ...',
      fr: 'Plus d\'histoires à venir ...',
      en: 'More stories coming soon ...',
      ru: 'Больше историй скоро ...',
    },

    subtitles: {
      de: 'Untertitel',
      fr: 'sous-titre',
      en: 'Subtitle',
      ru: 'подзаголовок',
    },

    play: {
      de: 'play',
      fr: 'play',
      en: 'play',
      ru: 'играть',
    },
    pause: {
      de: 'stop',
      fr: 'stop',
      en: 'stop',
      ru: 'CTOП',
    },

    newsletter: {
      de: 'newsletter',
      fr: 'newsletter',
      en: 'newsletter',
      ru: 'Новостная рассылка',
    },

    email: {
      de: 'email',
      fr: 'courriel',
      en: 'email',
      ru: 'Эл. адрес',
    },
    password: {
      de: 'passwort',
      fr: 'mot de passe',
      en: 'password',
      ru: 'пароль',
    },

    passwordReset: {
      de: 'neues passwort',
      fr: 'nouveau mot de passe',
      en: 'new password',
      ru: 'новый пароль',
    },
    passwordRepeat: {
      de: 'neues passwort wiederholen',
      fr: 'répéter nouveau mot de passe',
      en: 'repeat new password',
      ru: 'повторите новый пароль',
    },
    passwordResetConfirm: {
      de: 'passwort zurücksetzen',
      fr: 'réinitialiser le mot de passe',
      en: 'reset password',
      ru: 'Сброс пароля',
    },
    passwordResetError: {
      de: 'Bitte zwei mal das selbe, neue Passwort eingeben.',
      fr: 'S\'il vous plaît entrer le même nouveau mot de passe deux fois.',
      en: 'Please enter the same new password twice.',
      ru: 'Пожалуйста, введите один и тот же новый пароль дважды.',
    },

    admin: {
      de: 'admin',
      fr: 'admin',
      en: 'admin',
      ru: 'админ',
    },

    loginEmpty: {
      de: 'Bitte Email und Passwort eingeben.',
      fr: 'Veuillez entrer votre email et votre mot de passe.',
      en: 'Please enter email and password.',
      ru: 'введите адрес электронной почты и пароль.',
    },

    loginInvalid: {
      de: 'Benutzername und Password ungültig.',
      fr: 'Nom d\'utilisateur et mot de passe invalides.',
      en: 'Username and password invalid.',
      ru: 'Имя пользователя и пароль недействительны.',
    },

    serverError: {
      de: 'Es ist ein Fehler aufgetreten.',
      fr: 'Une erreur est survenue.',
      en: 'An error has occurred.',
      ru: 'Там была ошибка.',
    },

    resetHistory: {
      de: 'Verlauf zurücksetzen',
      fr: 'Réinitialiser l\'historique',
      en: 'Reset history',
      ru: 'Сбросить историю',
    },
    resetHistorySuccess: {
      de: 'Verlauf wurde zurückgesetzt.',
      fr: 'L\'histoire a été réinitialisée.',
      en: 'History has been reset.',
      ru: 'История была сброшена.',
    },

    forties: {
      de: '40er',
      fr: '40s',
      en: '40s',
      ru: '40-е',
    },

    fifties: {
      de: '50er',
      fr: '50s',
      en: '50s',
      ru: '50-е',
    },

    sixties: {
      de: '60er',
      fr: '60s',
      en: '60s',
      ru: '60-е',
    },

    seventies: {
      de: '70er',
      fr: '70s',
      en: '70s',
      ru: '70-е',
    },

    eighties: {
      de: '80er',
      fr: '80s',
      en: '80s',
      ru: '80-е',
    },

    nineties: {
      de: '90er',
      fr: '90s',
      en: '90s',
      ru: '90-е',
    },

    all: {
      de: 'alle',
      fr: 'tous',
      en: 'all',
      ru: 'все',
    },

    advanced: {
      de: 'erweitert',
      fr: 'avancé',
      en: 'advanced',
      ru: 'передовой',
    },

    download: {
      de: 'download',
      fr: 'télécharger',
      en: 'download',
      ru: 'скачать',
    },

    subscribe: {
      de: 'anmelden',
      fr: 'abonner',
      en: 'subscribe',
      ru: 'подписываться',
    },

    unsubscribe: {
      de: 'abmelden',
      fr: 'désabonner',
      en: 'unsubscribe',
      ru: 'отказаться',
    },

    subscribeSuccess: {
      de: 'Anmeldung erfolgreich',
      fr: 'Abonnement réussi',
      en: 'Subscription successful',
      ru: 'Подписка успешно',
    },

    unsubscribeSuccess: {
      de: 'Abmeldung erfolgreich',
      fr: 'Désabonné avec succès',
      en: 'Successfully unsubscribed',
      ru: 'Успешно отписался',
    },

    subscribeErrorEmail : {
      de: 'Bitte Email eingeben.',
      fr: 'Veuillez entrer un email.',
      en: 'Please enter an email.',
      ru: 'введите адрес электронной почты.',
    },

  }

  return translations[id][lang]

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/getTranslation/getTranslation.js